import React from 'react';
import { useNavigate } from 'react-router-dom';
import { typeByKey, fmtDateTime } from '../constants';

// "Continue where you left off" — the dashboard remembers, so you don't have to.
export default function ContinueSection({ items = [], t, locale }) {
  const navigate = useNavigate();
  if (items.length === 0) return null;
  return (
    <section className="crs-continue" data-testid="creator-continue-section">
      <p className="crs-section__label">{t.cr_continue_where || 'Continue where you left off'}</p>
      <div className="crs-continue__grid">
        {items.map((it) => {
          const type = typeByKey(it.type);
          const Icon = type?.icon;
          return (
            <button
              key={it.id}
              type="button"
              className="crs-continue__card"
              data-testid={`creator-continue-${it.id}`}
              onClick={() => navigate(`/creator/item/${it.id}`)}
            >
              <span className="crs-continue__icon" style={{ color: type?.color || '#b5ac9e' }}>
                {Icon && <Icon size={18} strokeWidth={1.4} />}
              </span>
              <span className="crs-continue__title">{it.title}</span>
              <span className="crs-continue__meta">
                {type ? (t[type.labelKey] || it.type) : ''}
                {' \u00b7 '}
                {t.cr_last_edited || 'Last edited'}: {fmtDateTime(it.updated_at, locale)}
              </span>
              <span className="crs-continue__go">{t.cr_continue || 'Continue'} →</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
